export const ADMIN_USER_TYPE = 3;

export const EXPORT_TYPE_PDF = "PDF";

export const SHORT_DATE_FORMAT = "DD MMM";

export const DATE_FORMAT = "M-D-yyyy";

export const DATE_FORMAT_STANDARD = "MM/DD/YYYY";

export const DATE_TIME_FORMAT = "DD/MM/YYYY, HH:mm:ss";

export const MYSQL_DATE_FORMAT = "yyyy-M-D";
export const MYSQL_DATE_FORMAT_LONG = "YYYY-MM-DD";

export const MYSQL_DATE_FORMAT_PADDED = "yyyy-MM-DD";

export const AWARD_LEVEL_OPTIONS = [
  {
    label: "White",
    value: "WHITE",
  },
  {
    label: "Yellow",
    value: "YELLOW",
  },
  {
    label: "Red",
    value: "RED",
  },
  {
    label: "Brown",
    value: "BROWN",
  },
  {
    label: "Black",
    value: "BLACK",
  },
];

export const NAME_ORDERING_OPTIONS = [
  {
    label: "First Last Name",
    value: "FIRST_LAST_NAME",
  },
  {
    label: "Last First Name",
    value: "LAST_FIRST_NAME",
  },
];

export const GENDER_OPTIONS = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Male",
    value: "M",
  },
  {
    label: "Female",
    value: "F",
  },
];

export const MEMBER_SET_OPTIONS = [
  {
    label: "Members and staff",
    value: "MEMBERS_AND_STAFF",
  },
  {
    label: "Members only",
    value: "MEMBERS_ONLY",
  },
  {
    label: "Staff only",
    value: "STAFF_ONLY",
  },
];

export const EMAIL_VIEW_BY_OPTIONS = [
  {
    label: "My Members",
    value: "MY_MEMBERS",
  },
  {
    label: "All Members",
    value: "ALL_MEMBERS",
  },
];

export const EMAIL_MEMBER_STATUS_OPTIONS = [
  {
    label: "Active",
    value: "ACTIVE",
  },
  {
    label: "Inactive",
    value: "IN_ACTIVE",
  },
  {
    label: "Terminated",
    value: "TERMINATED",
  },
];

export const EMAIL_SORT_BY_OPTIONS = [
  {
    label: "Member",
    value: "MEMBER",
  },
  {
    label: "Email Address",
    value: "EMAIL_ADDRESS",
  },
  {
    label: "Instructor",
    value: "INSTRUCTOR",
  },
  {
    label: "Status",
    value: "STATUS",
  },
];

export const EMAIL_SORT_ORDER_OPTIONS = [
  {
    label: "Ascending Order",
    value: "ASC",
  },
  {
    label: "Descending Order",
    value: "DESC",
  },
];

export const INSTRUCTOR_MSG_SORT_ORDER_OPTIONS = [
  {
    label: "Ascending Order",
    value: "ASC",
  },
  {
    label: "Descending Order",
    value: "DESC",
  },
];

export const MEMBER_RANKING_VALUED_BY_OPTIONS = [
  {
    label: "Fitness Points Earned",
    value: "FITNESS_POINTS_EARNED",
  },
  {
    label: "Total Weight Lifted",
    value: "TOTAL_WEIGHT_LIFTED",
  },
  {
    label: "Total Cv Time",
    value: "TOTAL_CV_TIME",
  },
  {
    label: "Total Workout Sessions",
    value: "TOTAL_WORKOUT_SESSIONS",
  },
  {
    label: "Total Calories",
    value: "TOTAL_CALORIES",
  },
  {
    label: "Total Workout Days",
    value: "TOTAL_WORKOUT_DAYS",
  },
];

export const MEMBER_RANKING_AGE_GROUP_OPTIONS = [
  {
    label: "All",
    value: "ALL",
  },
  {
    label: "20",
    value: "TWENTY",
  },
  {
    label: "40",
    value: "FORTY",
  },
  {
    label: "50",
    value: "FIFTY",
  },
  {
    label: "60",
    value: "SIXTY",
  },
  {
    label: "70",
    value: "SEVENTY",
  },
  {
    label: "80",
    value: "EIGHTY",
  },
];

export const VIEW_INTERVAL_OPTIONS = [
  {
    label: "This Month",
    value: "THIS_MONTH",
  },
  {
    label: "Last Month",
    value: "LAST_MONTH",
  },
  {
    label: "Year-to-date",
    value: "YEAR_TO_DATE",
  },
  {
    label: "Lifetime",
    value: "LIFETIME",
  },
  {
    label: "Custom",
    value: "CUSTOM",
  },
];

export const VIEW_INTERVAL_OPTIONS_JOURNAL = [
  {
    label: "Last 30 days",
    value: "LAST_30_DAYS",
  },
  {
    label: "Last 3 Months",
    value: "LAST_3_MONTHS",
  },
  {
    label: "Last 12 Months",
    value: "LAST_12_MONTHS",
  },
  {
    label: "Custom",
    value: "CUSTOM",
  },
];

export const INTERVAL_OPTIONS = [
  {
    label: "This Month",
    value: "THIS_MONTH",
  },
  {
    label: "Last Month",
    value: "LAST_MONTH",
  },
  {
    label: "Year-to-date",
    value: "YEAR_TO_DATE",
  },
  {
    label: "Lifetime",
    value: "LIFETIME",
  },
  {
    label: "Custom",
    value: "CUSTOM",
  },
];

export const CANCELLATION_SORT_BY_OPTIONS = [
  {
    label: "Cancellation Reason",
    value: "CANCELLATION_REASON",
  },
  {
    label: "Instructor Last Name",
    value: "INSTRUCTOR_LAST_NAME",
  },
  {
    label: "Member Last Name",
    value: "MEMBER_LAST_NAME",
  },
];

export const MEMBER_CHART_VALUE_BY = [
  { label: "Time", value: "TIME" },
  { label: "Calories", value: "CALORIES" },
];

export const MEMBER_REPORT_STATUS = [
  {
    label: "Active Members Only",
    value: "ACTIVE",
  },
  {
    label: "Inactive Members",
    value: "IN_ACTIVE",
  },
  {
    label: "Terminated Members",
    value: "TERMINATED",
  },
];

export const MEMBER_REPORT_SORT_BY_OPTIONS = [
  {
    label: "Member",
    value: "MEMBER",
  },
  {
    label: "FitLinxx ID",
    value: "FITLINXX_ID",
  },
  {
    label: "Data Signed Up",
    value: "DATA_SIGNED_UP",
  },
  {
    label: "Instructor",
    value: "INSTRUCTOR",
  },
  {
    label: "Status",
    value: "STATUS",
  },
  {
    label: "Expiration Date",
    value: "EXPIRATION_DATE",
  },
  {
    label: "Payment Schedule",
    value: "PAYMENT_SCHEDULE",
  },
  {
    label: "T-Shirt Size",
    value: "T_SHIRT_SIZE",
  },
];

export const ASC = "ascending";
export const DESC = "descending";

export const COUNTRIES = [
  "Australia",
  "Belgium",
  "Canada",
  "Denmark",
  "France",
  "Germany",
  "Hungary",
  "India",
  "Ireland",
  "Italy",
  "Luxembourg",
  "Netherlands",
  "New Zealand",
  "Portugal",
  "Spain",
  "Sweden",
  "Switzerland",
  "Turkey",
  "UAE",
  "United Kingdom",
  "USA",
];

export const USA_STATES = [
  "AL",
  "AR",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DC",
  "DE",
  "FL",
  "GA",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
];

export const COUNTRY_ISO3_CODES = {
  Australia: {
    hint: "Country code - +61, begins with - 4, length - 9",
    iso2: "AU",
    iso3: "AUS",
  },
  Belgium: {
    hint: "Country code - +32, begins with - 4 or 3, length - 9 or 8",
    iso2: "BE",
    iso3: "BEL",
  },
  Canada: {
    hint: "Country code - +1, format - XXX-XXX-XXXX, length - 10",
    iso2: "CA",
    iso3: "CAN",
  },
  Denmark: {
    hint: "Country code - +45, length - 8",
    iso2: "DK",
    iso3: "DNK",
  },
  France: {
    hint: "Country code - +33, begins with - 6 or 7, length - 9",
    iso2: "FR",
    iso3: "FRA",
  },
  Germany: {
    hint: "Country code - +49, begins with - 15 or 16 or 17, length - 10 or 11",
    iso2: "DE",
    iso3: "DEU",
  },
  Hungary: {
    hint: "Country code - +36, begins with - 20 or 30 or 31 or 50 or 70, length - 9",
    iso2: "HU",
    iso3: "HUN",
  },
  India: {
    hint: "Country code - +91, begins with - 6 or 7 or 8 or 9, length - 10",
    iso2: "IN",
    iso3: "IND",
  },
  Ireland: {
    hint: "Country code - +353, length - 9",
    iso2: "IE",
    iso3: "IRL",
  },
  Italy: {
    hint: "Country code - +39, begins with - 3, length - 9 or 10",
    iso2: "IT",
    iso3: "ITA",
  },
  Luxembourg: {
    hint: "Country code - +352, begins with - 6, length - 9",
    iso2: "LU",
    iso3: "LUX",
  },
  Netherlands: {
    hint: "Country code - +31, begins with - 6, length - 9",
    iso2: "NL",
    iso3: "NLD",
  },
  "New Zealand": {
    hint: "Country code - +64, begins with - 2, length - 8 or 9 or 10",
    iso2: "NZ",
    iso3: "NZL",
  },
  Portugal: {
    hint: "Country code - +351, begins with - 9, length - 9",
    iso2: "PT",
    iso3: "PRT",
  },
  Spain: {
    hint: "Country code - +34, begins with - 6 or 7, length - 9",
    iso2: "ES",
    iso3: "ESP",
  },
  Sweden: {
    hint: "Country code - +46, begins with - 7, length - 9",
    iso2: "SE",
    iso3: "SWE",
  },
  Switzerland: {
    hint: "Country code - +41, begins with - 74 or 75 or 76 or 77 or 78 or 79, length - 9",
    iso2: "CH",
    iso3: "CHE",
  },
  Turkey: {
    hint: "Country code - +90, begins with - 5, length - 10",
    iso2: "TR",
    iso3: "TUR",
  },
  UAE: {
    hint: "Country code - +971, begins with - 5, length - 9",
    iso2: "AE",
    iso3: "ARE",
  },
  USA: {
    hint: "Country code - +1, format - XXX-XXX-XXXX, length - 10",
    iso2: "US",
    iso3: "USA",
  },
  "United Kingdom": {
    hint: "Country code - +44, begins with - 7, length - 10",
    iso2: "GB",
    iso3: "GBR",
  },
};

export const NANP_ISO2_LIST = ["US", "CA"];

export const MONTH_OPTIONS = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

export const JOURNAL_ENTRY_CATEGORY = "JOURNAL_NOTE";

export const MEMBER_STAT_SORT_BY = [
  {
    label: "Accounting Code",
    value: "ACCOUNTING_CODE",
  },
  {
    label: "Age",
    value: "AGE",
  },
  {
    label: "Days Since Last Message",
    value: "DAYS_SINCE_LAST_MESSAGE",
  },
  {
    label: "Days Since Last Workout Session",
    value: "DAYS_SINCE_LAST_WORKOUT_SESSION",
  },
  {
    label: "FitLinxx ID",
    value: "FITLINXX_ID",
  },
  {
    label: "Instructor Last Name",
    value: "INSTRUCTOR_LAST_NAME",
  },
  {
    label: "Member Last name",
    value: "MEMBER_LAST_NAME",
  },
  {
    label: "Sex",
    value: "SEX",
  },
  {
    label: "Sign Up Date",
    value: "SIGN_UP_DATE",
  },
  {
    label: "Status",
    value: "STATUS",
  },
  {
    label: "Total Points",
    value: "TOTAL_POINTS",
  },
  {
    label: "Total Workout Sessions",
    value: "TOTAL_WORKOUT_SESSIONS",
  },
  {
    label: "Workout Sessions Since Last Message",
    value: "WORKOUT_SESSIONS_SINCE_LAST_MSG",
  },
];

export const DEFAULT_MEMBER_STATUS = "FITLINXX_FREE";

export const GENERIC_MEMBER_STATUS_OPTIONS = [
  { isSelectAll: true, label: "All Status", value: "" },
  { label: "FitLinxx Free", value: "FITLINXX_FREE" },
  { label: "Inactive", value: "IN_ACTIVE" },
  { label: "Terminated Facility", value: "TERMINATED_FACILITY" },
  { label: "Staff as Member", value: "FITLINXX_STAFF" },
  { label: "FitLinxx Demo", value: "DEMO" },
  { label: "FitLinxx Trial", value: "FITLINXX_TRIAL" },
  { label: "FitLinxx Free Waived", value: "FITLINXX_FEE_WAIVED" },
  { label: "Paying for FitLinxx", value: "PAYING_FOR_FITLINXX" },
  { label: "Terminated FitLinxx", value: "TERMINATED" },
];

export const MEMBER_STATUS_ALLOWED_FOR_DELETE = ["FITLINXX_TRIAL", "DEMO"];
export const MEMBER_NOT_DELETABLE_ERR_MSG: {
  label: string;
  type: "info" | "success" | "warning" | "error" | "default";
} = {
  label: "Only trials & demo members can be deleted.",
  type: "info",
};

export const STAFF_STATUS_OPTIONS = [
  { isSelectAll: true, label: "All Status", value: "" },
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "IN_ACTIVE" },
];

export const STAFF_TYPES = [
  { isSelectAll: true, label: "All Types", value: "" },
  { label: "Admin", value: "ADMIN" },
  { label: "Instructor", value: "INSTRUCTOR" },
];

export const enum WorkflowStates {
  locked = "locked",
  active = "active",
  complete = "complete",
}

export const TCA_REMS_SS_THRESHOLD = 7;
export const TCA_REMS_SM_THRESHOLD = 8;
export const TCA_REMS_ATD_THRESHOLD = 10;

export const EXERCISE_READINESS_QUESTIONS_AND_ANSWERS = [
  {
    answer: `Over the age of 65 and not accustomed to vigorous exercise`,
    question: `Are you over age 65 and not accustomed to vigorous exercise?`,
  },
  {
    answer: `Frequently has pains in heart and chest`,
    question: `Do you frequently have pains in your heart and chest?`,
  },
  {
    answer: `Often feels faint or has spells of severe dizziness`,
    question: `Do you often feel faint or have spells of severe dizziness?`,
  },
  {
    answer: `Doctor reported blood pressure was too high`,
    question: `Has a doctor ever said that your blood pressure was too high?`,
  },
  {
    answer: `Doctor reported a bone or joint problem such as arthritis that has been aggravated by exercise`,
    question: `Has a doctor ever told you that you have a bone or joint problem such as arthritis that has been aggravated by exercise?`,
  },
  {
    answer: `Doctor reported having heart trouble`,
    question: `Has your doctor ever said that you have heart trouble?`,
  },
  {
    answer: `A good physical reason requires not participating in an activity program`,
    question: `Is there a good physical reason not mentioned here why you should not follow an activity program even if you wanted to?`,
  },
];

// #region dictionary
export const MSG_ENTRY_SAVED_SUCCESSFULLY = "Entry saved successfully";
export const MSG_OPERATION_FAILED = "Operation failed";
export const MSG_OPERATION_SUCCESSFUL = "Operation successful";
// #endregion dictionary

export const DOCUMENT_BEING_SENT = "Document is being sent";
export const DOCUMENT_BEING_PROCESSED = "Document is being processed";
export const DOCUMENT_SENT_SUCCESSFUL = "Document sent succesfully";
export const DOCUMENT_SENT_FAILED = "Document failed to be sent";

export const EMAIL_VALIDATION_VALIDATING = "Email address is being validated";
export const EMAIL_VALIDATION_MISSING_CREDITS = "Email not able to be validated, pending credits";
export const EMAIL_VALIDATION_FAILED = "Failed to validate email, connection error";
export const EMAIL_VALIDATION_INVALID = "Email address provided is Invalid";
